import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function DoorGlass() {
  const points = ['Entry door glass replacement', 'Patio door and sliding door glass', 'Storm door glass', 'Decorative and patterned glass inserts', 'Interior door glass', 'Safety glass options when required'];
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-slate-50 border-t border-slate-200" data-id="element-39">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-40">
        <div data-id="element-41">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight mb-6" data-id="element-42">
            Door Glass, Patio Door Glass & Decorative Inserts
          </h2>
          <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-43">
            Kosin’s Glass repairs and replaces residential door glass, including
            entry doors, patio doors, storm doors, interior doors and decorative
            glass inserts. Whether the glass is broken, foggy, outdated or no
            longer fits your style, the team can help measure and recommend
            replacement options.
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8" data-id="element-44">
            {points.map((point, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-45">
                <CheckCircle2 className="w-5 h-5 text-brandBlue-600 flex-shrink-0 mt-0.5" data-id="element-46" />
                <span className="text-slate-700 font-medium" data-id="element-47">{point}</span>
              </li>)}
          </ul>
          <a href="#estimate-form" className="inline-flex items-center justify-center bg-white border-2 border-brandBlue-600 text-brandBlue-600 hover:bg-brandBlue-50 font-bold text-lg py-3 px-8 rounded-xl transition-colors" data-id="element-48">
            Get a Door Glass Estimate
          </a>
        </div>
        <div className="bg-slate-200 rounded-2xl aspect-video lg:aspect-square w-full flex items-center justify-center overflow-hidden relative" data-id="element-49">
          {/* Placeholder for actual image */}
          <div className="absolute inset-0 bg-gradient-to-tr from-slate-300 to-slate-200 opacity-50" data-id="element-50"></div>
          <span className="text-slate-400 font-medium relative z-10" data-id="element-51">
            Door Glass Imagery
          </span>
        </div>
      </div>
    </section>;
}